import { SortDirection } from 'constants/SortDirection';
import { action, makeObservable, runInAction } from 'mobx';
import { destroy, EntityName, getCount, getDetailsForCorrectPagination, getPage } from 'stores/_services/dataService';
import BaseListStore, { DEFAULT_LIMIT, DEFAULT_PAGE_NUMBER } from 'stores/BaseListStore';
import ExtensionGlobalVariableStore from 'stores/extensionGlobalVariable/ExtensionGlobalVariableStore';
import { getConditions } from 'stores/_services/filterService';
import { IGetDataParams } from '../../types';

const SEARCH_FIELDS = ['name', 'type', 'value'];

export default class ExtensionGlobalVariableListStore extends BaseListStore<ExtensionGlobalVariableStore> {
    constructor() {
        super({
            itemStore: ExtensionGlobalVariableStore,
            sortBy: 'name',
            sortDirection: SortDirection.ASC
        });

        makeObservable(this, {
            getExtensionGlobalVariableList: action
        });
    }

    async getExtensionGlobalVariableList(args = {}, pageNumber = DEFAULT_PAGE_NUMBER, pageSize = DEFAULT_LIMIT): Promise<void> {
        const conditions = getConditions(this.filter);

        this._updateListState(args);

        const options = {
            filter: {
                order: this.sort,
                limit: pageSize,
                skip: (pageNumber - 1) * pageSize,
                searchFields: SEARCH_FIELDS,
                where: conditions
            }
        };

        const { data } = await getPage(EntityName.EXTENSIONS_GLOBAL_VARIABLES, options);
        const totalCount = await getCount(EntityName.EXTENSIONS_GLOBAL_VARIABLES, {
            where: conditions,
            searchFields: SEARCH_FIELDS
        });

        this._updateData(data);
        this._updateIds(data, this.skip);
        this._updateCount(data);

        runInAction(() => {
            this.count = data.length;
            this.totalCount = totalCount;
            this.page = pageNumber;
            this.pageSize = pageSize;
        });
    }

    async getExtensionGlobalVariableListForCorrectPagination(args: IGetDataParams = {}): Promise<void> {
        const { filter, sortBy, sortDirection, pageSize, page } = args;

        const params = {
            filter: filter || this.filter,
            sortBy: sortBy || this.sortBy,
            sortDirection: sortDirection || this.sortDirection,
            pageSize: pageSize || this.pageSize,
            page: page || this.page,
            searchFields: SEARCH_FIELDS
        };

        const { data, totalCount } = await getDetailsForCorrectPagination<ExtensionGlobalVariableStore>({
            params,
            entityName: EntityName.EXTENSIONS_GLOBAL_VARIABLES
        });

        this.updateStateForCorrectPagination<ExtensionGlobalVariableStore>({ args, data, totalCount });
    }

    async deleteGlobalVariable(variableId: string): Promise<void> {
        await destroy(`${EntityName.EXTENSIONS_GLOBAL_VARIABLES}/${variableId}`);
    }
}
